import { ComponentProps } from 'react';
import { PaymentProviderDto } from '@tiendanube/common';
import { PaymentProvidersCode } from '@tiendanube/common/src/domains/payments/providers/PaymentProvidersCode';
import {
  PAYMENTS_METHODS_NUVEMPAGO_ACTIVATED_STATUS,
  PAYMENTS_METHODS_NUVEMPAGO_DISABLED_STATUS,
  PAYMENTS_METHODS_NUVEMPAGO_INPROCESS_STATUS,
  PAYMENTS_METHODS_NUVEMPAGO_PENDING_STATUS,
} from 'config/trackingEvents';
import { PaymentProviderStatusLabel } from '../../pages/PaymentProvidersListPage/components/PaymentProviderStatusLabel';

function extractProps({
  isActive,
  mustCompleteInstallation,
  processingInstallation,
  isDeprecated,
  isNew,
}: PaymentProviderDto) {
  return {
    isActive,
    mustCompleteInstallation,
    processingInstallation,
    isDeprecated,
    isNew,
  };
}

export function getStatusLabelProps(
  provider: PaymentProviderDto,
  shouldPatchStatus: boolean,
): ComponentProps<typeof PaymentProviderStatusLabel> {
  if (provider.id !== PaymentProvidersCode.nuvemPago || !shouldPatchStatus)
    return extractProps(provider);

  if (provider.mustCompleteInstallation || provider.processingInstallation) {
    return {
      isActive: true,
      mustCompleteInstallation: false,
      processingInstallation: false,
      isDeprecated: false,
      isNew: false,
    };
  }

  return extractProps(provider);
}

export function getStatusTrackingEvent(
  provider: PaymentProviderDto,
  shouldPatchStatus: boolean,
): string | undefined {
  if (provider.id !== PaymentProvidersCode.nuvemPago) {
    return undefined;
  }

  const { isActive, mustCompleteInstallation, processingInstallation } =
    provider;

  if (isActive && !mustCompleteInstallation && !processingInstallation) {
    return PAYMENTS_METHODS_NUVEMPAGO_ACTIVATED_STATUS;
  }

  if (!isActive && !mustCompleteInstallation && !processingInstallation) {
    return PAYMENTS_METHODS_NUVEMPAGO_DISABLED_STATUS;
  }

  if (mustCompleteInstallation || processingInstallation) {
    if (shouldPatchStatus) {
      return PAYMENTS_METHODS_NUVEMPAGO_ACTIVATED_STATUS;
    } else if (processingInstallation) {
      return PAYMENTS_METHODS_NUVEMPAGO_INPROCESS_STATUS;
    } else {
      return PAYMENTS_METHODS_NUVEMPAGO_PENDING_STATUS;
    }
  }
}
